import React from 'react';
import './../scss/JobTile.scss';
const { __ } = window.wp.i18n;

class JobTile extends React.Component {
  render () {
    const theDate = this.props.data.indexed_at;
    const theDatelenth = theDate.length;
    const monthNames = [__('Jan', 'macs-react-jobs'), __('Feb', 'macs-react-jobs'), __('Mar', 'macs-react-jobs'), __('Apr', 'macs-react-jobs'), __('May', 'macs-react-jobs'), __('Jun', 'macs-react-jobs'), __('Jul', 'macs-react-jobs'), __('Aug', 'macs-react-jobs'), __('Sep', 'macs-react-jobs'), __('October', 'macs-react-jobs'), __('Nov', 'macs-react-jobs'), __('Dec', 'macs-react-jobs')];
    let d = new Date(parseInt(theDate * 1000));
    const pathName = `${window.es_var.pathName}`;
    let base_slug = '';

    if (pathName !== '') {
      base_slug = '/' + pathName;
    }

    if (theDatelenth > 10) {
      d = new Date(theDate);
    }

    function formatDate () {
      const month = '' + monthNames[d.getMonth()];
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (day.length < 2) day = '0' + day;
      return month + ' ' + day + ', ' + year;
    }

    /**
       * Convert title to the slug.
       *
       * @param {string} title Post title.
       *
       * @return {string}
       */
    function convertToSlug (title) {
      let jobTitle = title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
      jobTitle = jobTitle || '-';
      return jobTitle;
    }

    function getCountryNameByCode (CountryCode) {
      const pre_defined_country_list = [
        { key: 'fr-ma', value: __('Morocco', 'macs-react-jobs') },
        { key: 'ma-fr', value: __('Morocco', 'macs-react-jobs') },
        { key: 'nl-nl', value: __('Netherlands', 'macs-react-jobs') },
        { key: 'NL', value: __('Netherlands', 'macs-react-jobs') },
        { key: 'es-mx', value: __('Mexico', 'macs-react-jobs') },
        { key: 'mx-es', value: __('Mexico', 'macs-react-jobs') },
        { key: 'MX', value: __('Mexico', 'macs-react-jobs') },
        { key: 'it-it', value: __('Italy', 'macs-react-jobs') },
        { key: 'it', value: __('Italy', 'macs-react-jobs') },
        { key: 'IT', value: __('Italy', 'macs-react-jobs') },
        { key: 'ITA', value: __('Italy', 'macs-react-jobs') },
        { key: 'cn-zh', value: __('China', 'macs-react-jobs') },
        { key: 'zh-cn', value: __('China', 'macs-react-jobs') },
        { key: 'CHN', value: __('China', 'macs-react-jobs') },
        { key: 'zh-hans', value: __('China', 'macs-react-jobs') },
        { key: 'es-es', value: __('Spain', 'macs-react-jobs') },
        { key: 'ES', value: __('Spain', 'macs-react-jobs') },
        { key: 'DE', value: __('Germany', 'macs-react-jobs') },
        { key: 'de-de', value: __('Germany', 'macs-react-jobs') },
        { key: 'pl-pl', value: __('Poland', 'macs-react-jobs') },
        { key: 'PL', value: __('Poland', 'macs-react-jobs') },
        { key: 'en-pt', value: __('Portugal', 'macs-react-jobs') },
        { key: 'pt-en', value: __('Portugal', 'macs-react-jobs') },
        { key: 'PRT', value: __('Portugal', 'macs-react-jobs') },
        { key: 'PT', value: __('Portugal', 'macs-react-jobs') },
        { key: 'co-es', value: __('Colombia', 'macs-react-jobs') },
        { key: 'es-co', value: __('Colombia', 'macs-react-jobs') },
        { key: 'CO', value: __('Colombia', 'macs-react-jobs') },
        { key: 'fr-fr', value: __('France', 'macs-react-jobs') },
        { key: 'FR', value: __('France', 'macs-react-jobs') },
        { key: 'en-gb', value: __('United Kingdom', 'macs-react-jobs') },
        { key: 'gb-en', value: __('United Kingdom', 'macs-react-jobs') },
        { key: 'GB', value: __('United Kingdom', 'macs-react-jobs') },
        { key: 'au-en', value: __('Australia', 'macs-react-jobs') },
        { key: 'en-au', value: __('Australia', 'macs-react-jobs') },
        { key: 'AU', value: __('Australia', 'macs-react-jobs') },
        { key: 'nz-en', value: __('New Zealand', 'macs-react-jobs') },
        { key: 'en-nz', value: __('New Zealand', 'macs-react-jobs') },
        { key: 'NZ', value: __('New Zealand', 'macs-react-jobs') },
        { key: 'BE', value: __('Belgium', 'macs-react-jobs') },
        { key: 'be-en', value: __('Belgium', 'macs-react-jobs') },
        { key: 'en-be', value: __('Belgium', 'macs-react-jobs') },
        { key: 'ja', value: __('Japan', 'macs-react-jobs') },
        { key: 'JP', value: __('Japan', 'macs-react-jobs') },
        { key: 'en-us', value: __('United States', 'macs-react-jobs') },
        { key: 'us-en', value: __('United States', 'macs-react-jobs') },
        { key: 'US', value: __('United States', 'macs-react-jobs') },
        { key: 'en-in', value: __('India', 'macs-react-jobs') },
        { key: 'in-en', value: __('India', 'macs-react-jobs') },
        { key: 'IN', value: __('India', 'macs-react-jobs') },
        { key: 'SE', value: __('Sweden', 'macs-react-jobs') },
        { key: 'se-en', value: __('Sweden', 'macs-react-jobs') },
        { key: 'en-se', value: __('Sweden', 'macs-react-jobs') },
        { key: 'no-no', value: __('Norway', 'macs-react-jobs') },
        { key: 'NO', value: __('Norway', 'macs-react-jobs') },
        { key: 'RO', value: __('Romania', 'macs-react-jobs') },
        { key: 'AT', value: __('Austria', 'macs-react-jobs') },
        { key: 'DK', value: __('Denmark', 'macs-react-jobs') },
        { key: 'FI', value: __('Finland', 'macs-react-jobs') },
        { key: 'en-fi', value: __('Finland', 'macs-react-jobs') },
        { key: 'fi-en', value: __('Finland', 'macs-react-jobs') },
        { key: 'CH', value: __('Switzerland', 'macs-react-jobs') },
        { key: 'ch-en', value: __('Switzerland', 'macs-react-jobs') },
        { key: 'ch-fr', value: __('Switzerland', 'macs-react-jobs') },
        { key: 'en-ch', value: __('Switzerland', 'macs-react-jobs') },
        { key: 'ch-fr', value: __('Switzerland', 'macs-react-jobs') },
        { key: 'HU', value: __('Hungary', 'macs-react-jobs') },
        { key: 'pt-br', value: __('Brazil', 'macs-react-jobs') },
        { key: 'br-pt', value: __('Brazil', 'macs-react-jobs') },
        { key: 'BR', value: __('Brazil', 'macs-react-jobs') },
        { key: 'CZ', value: __('Czech Republic', 'macs-react-jobs') },
        { key: 'en-sg', value: __('Singapore', 'macs-react-jobs') },
        { key: 'sg-en', value: __('Singapore', 'macs-react-jobs') },
        { key: 'SG', value: __('Singapore', 'macs-react-jobs') },
        { key: 'es-ar', value: __('Argentina', 'macs-react-jobs') },
        { key: 'ar-es', value: __('Argentina', 'macs-react-jobs') },
        { key: 'AR', value: __('Argentina', 'macs-react-jobs') },
        { key: 'en-ca', value: __('Canada', 'macs-react-jobs') },
        { key: 'ca-en', value: __('Canada', 'macs-react-jobs') },
        { key: 'CA', value: __('Canada', 'macs-react-jobs') },
        { key: 'en-hk', value: __('Hong Kong SAR', 'macs-react-jobs') },
        { key: 'hk-en', value: __('Hong Kong SAR', 'macs-react-jobs') },
        { key: 'HK', value: __('Hong Kong SAR', 'macs-react-jobs') },
        { key: 'en-my', value: __('Malaysia', 'macs-react-jobs') },
        { key: 'my-en', value: __('Malaysia', 'macs-react-jobs') },
        { key: 'MY', value: __('Malaysia', 'macs-react-jobs') },
        { key: 'en-ph', value: __('Philippines', 'macs-react-jobs') },
        { key: 'ph-en', value: __('Philippines', 'macs-react-jobs') },
        { key: 'PH', value: __('Philippines', 'macs-react-jobs') },
        { key: 'tn-fr', value: __('Tunisia', 'macs-react-jobs') },
        { key: 'fr-tn', value: __('Tunisia', 'macs-react-jobs') },
        { key: 'TN', value: __('Tunisia', 'macs-react-jobs') },
        { key: 'LU', value: __('Luxembourg', 'macs-react-jobs') },
        { key: 'lu-en', value: __('Luxembourg', 'macs-react-jobs') },
        { key: 'en-lu', value: __('Luxembourg', 'macs-react-jobs') },
        { key: 'IE', value: __('Ireland', 'macs-react-jobs') },
        { key: 'ie-en', value: __('Ireland', 'macs-react-jobs') },
        { key: 'en-ie', value: __('Ireland', 'macs-react-jobs') }
      ];

      const FinalCountryName = pre_defined_country_list.filter(temp => (temp.key === CountryCode));
      if (FinalCountryName[0]) {
        return FinalCountryName[0].value;
      }

      return CountryCode;
    }

    return (
      <a className="table-tr filter-box tag-active joblink" href={base_slug + '/jobs/' + this.props.data._id + '/' + convertToSlug(this.props.data.title) + '/'}>
        <div className="table-td table-title" style={{ display: (this.props.filtercolumnselections).includes('job_name') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Job name', 'macs-react-jobs') }</span>
          <div>{this.props.data.title}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('country') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Country', 'macs-react-jobs') }</span>
          <div>{getCountryNameByCode(this.props.data.country_code)}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('location') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Location', 'macs-react-jobs') }</span>
          <div>{this.props.data.location}  </div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('experience_level') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Experience level', 'macs-react-jobs') }</span>
          <div>{this.props.data.experience_level}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('department') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Department', 'macs-react-jobs') }</span>
          <div>{this.props.data.department}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('contract_type') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Contract Type', 'macs-react-jobs') }</span>
          <div>{this.props.data.contract_type}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('business_units') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Business Unit', 'macs-react-jobs') }</span>
          <div>{this.props.data.sbu}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('professional_communities') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Professional communities', 'macs-react-jobs') }</span>
          <div>{this.props.data.professional_communities}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('brand') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Brand', 'macs-react-jobs') }</span>
          <div>{this.props.data.brand}</div>
        </div>
        { /*
        <div className="table-td table-title td-style">
          <span className="table-td-header">{ __( 'Posted on', 'macs-react-jobs' ) }</span>
          <div>{formatDate(theDate)}</div>
        </div>
      */ }
      </a>
    );
  }
}

export default JobTile;
